import { State } from "@/store/modules/webinar";

const setShowEnterModal = (state: State, payload: boolean) => {
  state.showEnterModal = payload;
};

const setHasPin = (state: State, payload: any) => {
  state.hasPin = payload;
};

const setRoomId = (state: State, payload: any) => {
  state.roomId = payload;
};

export default {
  setShowEnterModal,
  setHasPin,
  setRoomId,
};
